<template>
    <div class="wrap main_wrap">
        <!-- <UserLeftModal /> -->
        <router-view />
        <InfoModal v-if="store.getters.getUserInfoModalState" />
    </div>
</template>

<script setup>
// import UserLeftModal from '@/components/User/UserLeftModal.vue';
import InfoModal from '@/components/User/UserModal/InfoModal.vue';
import { onMounted } from 'vue';
import { useStore } from 'vuex';
const store = useStore();
// import '@/assets/user/js/common.js';

const loadScript = (src) => {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);

    });
};

onMounted(async () => {
    await loadScript('https://d3kx8o9mol3zjn.cloudfront.net/user/js/common.js')

});
</script>

<style>
@import "https://d3kx8o9mol3zjn.cloudfront.net/user/css/common.css";
@import "https://d3kx8o9mol3zjn.cloudfront.net/user/css/style.css";
</style>